var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fts-label-group"},[(_vm.emoji && _vm.getIcon)?_c('fts-moji',{class:_vm.getIconClass,attrs:{"emoji":_vm.getIcon,"size":_vm.emojiSize}}):(_vm.getIcon)?_c('i',{class:[
      _vm.getIcon,
      _vm.getIconClass,
      {'label-group__icon--system': _vm.isSystemDefault }
    ]}):_vm._e(),_vm._v(" "),_c('div',{class:_vm.getLabelClass},[_vm._v(_vm._s(_vm.getLabel))])],1)}
var staticRenderFns = []
export { render, staticRenderFns }